import { DependentDto } from "theSource/features/FamilyMembers/types";
import { SubscriberResponseDto } from "theSource/types";
import { ProfileWidget } from "./ProfileWidget";
import { DependentListContainerStyled } from "./DependentListStyled";

interface DependentListProps {
  dependents?: DependentDto[];
  subscriberProfile?: SubscriberResponseDto;
};

export const DependentList = ({
  dependents,
  subscriberProfile,
}: DependentListProps) => {
  
  return (
    <DependentListContainerStyled>
      <ProfileWidget firstName="You" profile={subscriberProfile?.data?.subscriber_profile} />
      {dependents?.map((dependent: DependentDto) => {
        return (
          <ProfileWidget firstName={dependent.first_name} birthdate={dependent.birthdate} profile={dependent.dependent_profile} />
        );
      })}
    </DependentListContainerStyled>
  );
};
